<template>
  <div>
    <v-form @submit.prevent="saveArticle">
      <!-- Títol -->
      <v-text-field
        v-model="article.title"
        label="Títol de l'article"
        required
        class="mb-4"
      ></v-text-field>

      <!-- Descripció curta -->
      <v-textarea
        v-model="article.description"
        label="Descripció curta"
        rows="3"
        required
        class="mb-4"
      ></v-textarea>

      <!-- Fitxer HTML -->
      <v-file-input
        v-model="htmlFile"
        label="Fitxer HTML de l'article"
        accept=".html"
        class="mb-4"
        @change="handleHtmlUpload"
        required
      ></v-file-input>

      <!-- Imatge destacada -->
      <v-file-input
        v-model="featuredImage"
        label="Imatge destacada"
        accept="image/*"
        class="mb-4"
        @change="handleImageUpload"
      ></v-file-input>

      <!-- Categories -->
      <v-combobox
        v-model="article.categories"
        label="Categories"
        multiple
        chips
        class="mb-4"
        :items="['Selectivitat', 'Consells', 'Notícies', 'Recursos', 'Dates importants']"
      ></v-combobox>

      <!-- Botons -->
      <div class="d-flex justify-end">
        <v-btn
          text
          class="mr-4"
          @click="cancel"
        >
          Cancel·lar
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          :loading="saving"
        >
          Publicar article
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'EditArticleComponent',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      article: {
        title: '',
        description: '',
        content: '',
        categories: [],
        featured_image: null,
        path: ''
      },
      htmlFile: null,
      featuredImage: null,
      saving: false
    }
  },
  async mounted() {
    if (this.id) {
      await this.loadArticle()
    }
  },
  methods: {
    async loadArticle() {
      try {
        const { data } = await this.axios.get(`/blog-articles/${this.id}`)
        this.article = data
      } catch (error) {
        console.error('Error carregant article:', error)
      }
    },
    async handleHtmlUpload(file) {
      if (!file) return
      
      const reader = new FileReader()
      reader.onload = (e) => {
        this.article.content = e.target.result
        // Generem el path a partir del nom del fitxer
        this.article.path = file.name.replace('.html', '')
          .replace(/[^\w\s]/gi, '')
          .split(' ')
          .join('-')
          .toLowerCase()
      }
      reader.readAsText(file)
    },
    async handleImageUpload(file) {
      if (!file) return
      
      const formData = new FormData()
      formData.append('image', file)
      
      try {
        const { data } = await this.axios.post('/blog-articles/upload-image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: this.$root.token.value
          }
        })
        this.article.featured_image = data.url
      } catch (error) {
        console.error('Error pujant imatge:', error)
      }
    },
    async saveArticle() {
      if (!this.article.content) {
        alert('Si us plau, selecciona un fitxer HTML')
        return
      }
      
      this.saving = true
      try {
        const method = this.id ? 'put' : 'post'
        const url = this.id ? `/blog-articles/${this.id}` : '/blog-articles'
        
        await this.axios[method](url, this.article, {
          headers: {
            Authorization: this.$root.token.value
          }
        })
        
        this.$router.push('/blog')
      } catch (error) {
        console.error('Error guardant article:', error)
      } finally {
        this.saving = false
      }
    },
    cancel() {
      this.$router.push('/blog')
    }
  }
}
</script>
